import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy, Inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

@Component({
    selector: 'app-session-timeout-popup',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SessionTimeoutPopupComponent implements OnInit, OnDestroy {
  constructor( @Inject(PLATFORM_ID) private platformId: object) { }

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Output() toClose: EventEmitter<unknown> = new EventEmitter()
  @Output() toContinue: EventEmitter<unknown> = new EventEmitter()

  timerObj: any

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const minutes = 1
    const display = document.querySelector('#timer')
    this.startTimer(minutes * 60, display)
  }

  ngOnDestroy(): void {
    if (this.timerObj) {
      clearInterval(this.timerObj)
    }
  }

  startTimer(duration, display) {
    let timer: any = duration
    let minutes
    let seconds
    this.timerObj = setInterval(() => {
      minutes = parseInt((timer / 60).toString(), 10)
      seconds = parseInt((timer % 60).toString(), 10)

      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      display.textContent = minutes + ':' + seconds

      if (--timer < 0) {
        // out part
        this.close()
      }
    }, 1000)
  }

  close() {
    this.toClose.emit(true)
  }
  continue() {
    this.toContinue.emit(true)
  }

}
